
// this function is used to filter the data based on the filter text throughout the table

export const filterFromData = (tableData, filterText) => {
  if (!filterText) {
    return tableData;
  }

  return tableData && tableData.filter(item => {
    return Object.values(item).some(value =>
      value && value.toString().toLowerCase().includes(filterText.toLowerCase())
    );
  });
};
